/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/resources/ts/jquery.syncHeight.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/resources/ts/jquery.syncHeight.ts":
/*!***********************************************!*\
  !*** ./src/resources/ts/jquery.syncHeight.ts ***!
  \***********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

///<reference types="jquery"/>
(function ($, window, document) {
    /**
     * Sync Height jQuery Plugin.
     *
     * Applies on window resize the height of a reference element to a configuration set of sync elements.
     * Configuration example:
     * 	{
     * 		refElementSelector: '<ReferenceElement-jQuery-CSS3-Selector>',
     * 			syncElementSelectors: {
     * 				'0': '<"ViewPort >= 0"-jQuery-CSS3-Selector>',
     * 				'768': '<"ViewPort >= 768"-jQuery-CSS3-Selector>'
     * 			}
     * 	}
     */
    var Plugin = /** @class */ (function () {
        /**
         * Initializes a new instance of the plugin.
         *
         * @param element   The DOM element.
         * @param options   Plugin options.
         */
        function Plugin(element, options) {
            this.defaults = {
                refElementSelector: '',
                syncElementSelectors: {}
            };
            this.element = element;
            this.$element = $(element);
            // extend default options
            this.options = $.extend({}, this.defaults, options);
            // init plugin
            this.init();
        }
        /**
         * Initialization.
         */
        Plugin.prototype.init = function () {
            this.$refElement = $(this.options.refElementSelector, this.$element);
            if (this.$refElement.length === 0) {
                return;
            }
            this.syncHeight();
            this.registerEvents();
        };
        Plugin.prototype.registerEvents = function () {
            $(window).bind("resize." + Plugin.NAME, $.proxy(this.syncHeight, this));
        };
        /**
         * Returns all sync elements of the current breakpoint.
         *
         * @returns {JQuery}
         */
        Plugin.prototype.getSyncElements = function () {
            var syncElements = $();
            if (this.options.syncElementSelectors) {
                var viewportWidth_1 = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                var maxValidBreakpoint_1 = 0;
                $.each(this.options.syncElementSelectors, function (selectorBreakpoint, selector) {
                    var breakpoint = parseInt(selectorBreakpoint, 10);
                    if (breakpoint <= viewportWidth_1 && breakpoint >= maxValidBreakpoint_1) {
                        maxValidBreakpoint_1 = breakpoint;
                    }
                });
                syncElements = $(this.options.syncElementSelectors[maxValidBreakpoint_1]);
            }
            return syncElements;
        };
        /**
         * Returns the height of the reference element.
         *
         * @returns {number}
         */
        Plugin.prototype.getSyncHeight = function () {
            return this.$refElement.height();
        };
        /**
         * Purges sync height from all possible targets.
         */
        Plugin.prototype.clearSync = function () {
            var _this = this;
            if (!this.options.syncElementSelectors) {
                return;
            }
            $.each(this.options.syncElementSelectors, function (breakpoint, selector) {
                $(selector, _this.$element).css('height', '');
            });
        };
        /**
         * Applies sync height to all target elements.
         * Purges old sync before.
         */
        Plugin.prototype.syncHeight = function () {
            this.clearSync();
            this.getSyncElements().css('height', this.getSyncHeight() + "px");
        };
        Plugin.NAME = 'syncHeight';
        return Plugin;
    }());
    $.fn[Plugin.NAME] = function (options) {
        return this.each(function () {
            var $this = $(this);
            if (!$this.data(Plugin.NAME)) {
                $this.data(Plugin.NAME, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);


/***/ })

/******/ });
//# sourceMappingURL=jquery.syncHeight.js.map